import memoizeOne from 'react-utils/memoizeOne';
import { getPortalId, getProjectName } from '../../../common/utils';
export const getPath = memoizeOne(({
  channel,
  allowHubless = false
}) => {
  let portalId = getPortalId();
  if (allowHubless && !portalId) {
    portalId = 'hubless';
  }
  const url = `/notifications/${portalId}/${channel}`;
  return url;
});
export const getQueryParams = memoizeOne(() => ({
  hostAppName: encodeURIComponent(getProjectName()),
  completeHostUrl: encodeURIComponent(window.location.href)
}));